import { render, staticRenderFns } from "./HeaderTraders.vue?vue&type=template&id=c1b4a0f0&scoped=true&"
import script from "./HeaderTraders.vue?vue&type=script&lang=js&"
export * from "./HeaderTraders.vue?vue&type=script&lang=js&"
import style0 from "./HeaderTraders.vue?vue&type=style&index=0&id=c1b4a0f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b4a0f0",
  null
  
)

export default component.exports